import script from "./ProjectManagerLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectManagerLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProjectManagerLayout.vue?vue&type=style&index=0&id=3c27f4b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c27f4b4"]])

export default __exports__